var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMoneyGrey(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.167 5.13379H3.83366C2.91318 5.13379 2.16699 5.87998 2.16699 6.80046V13.1921C2.16699 14.1126 2.91318 14.8588 3.83366 14.8588H17.167C18.0875 14.8588 18.8337 14.1126 18.8337 13.1921V6.80046C18.8337 5.87998 18.0875 5.13379 17.167 5.13379Z",
    stroke: "#B0B7C3",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.50033 5.54199C5.50033 6.42605 5.14914 7.27389 4.52401 7.89901C3.89889 8.52414 3.05105 8.87533 2.16699 8.87533V8.87533",
    stroke: "#B0B7C3",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.16699 11.0586C3.05105 11.0586 3.89889 11.4098 4.52401 12.0349C5.14914 12.66 5.50033 13.5079 5.50033 14.3919",
    stroke: "#B0B7C3",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5 14.3919C15.5 13.5079 15.8512 12.66 16.4763 12.0349C17.1014 11.4098 17.9493 11.0586 18.8333 11.0586",
    stroke: "#B0B7C3",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8333 8.87533C17.9493 8.87533 17.1014 8.52414 16.4763 7.89901C15.8512 7.27389 15.5 6.42605 15.5 5.54199V5.54199",
    stroke: "#B0B7C3",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5007 11.6673C11.4211 11.6673 12.1673 10.9211 12.1673 10.0007C12.1673 9.08018 11.4211 8.33398 10.5007 8.33398C9.58018 8.33398 8.83398 9.08018 8.83398 10.0007C8.83398 10.9211 9.58018 11.6673 10.5007 11.6673Z",
    stroke: "#B0B7C3",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoneyGrey);
export default __webpack_public_path__ + "static/media/moneyGrey.d167d741.svg";
export { ForwardRef as ReactComponent };